import { forwardRef, type Ref, type SVGProps } from "react";
const IconAttachmentFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.19 3.564A5.38 5.38 0 0 1 18 2c1.371 0 2.761.515 3.81 1.564C22.876 4.628 23.5 6.151 23.5 8v14c0 4.828-3.672 8-7.5 8-1.823 0-3.71-.608-5.155-1.972C9.38 26.644 8.5 24.603 8.5 22V11a1.5 1.5 0 0 1 3 0v11c0 1.897.62 3.106 1.405 3.847C13.71 26.608 14.823 27 16 27c2.172 0 4.5-1.828 4.5-5V8c0-1.15-.375-1.878-.81-2.314A2.38 2.38 0 0 0 18 5c-.629 0-1.239.235-1.69.686-.435.436-.81 1.163-.81 2.314v11c0 .496.133.765.221.875.066.082.135.125.279.125s.213-.043.279-.125c.088-.11.221-.379.221-.875v-8a1.5 1.5 0 0 1 3 0v8c0 1.004-.267 1.985-.879 2.75A3.3 3.3 0 0 1 16 23a3.3 3.3 0 0 1-2.621-1.25c-.612-.765-.879-1.746-.879-2.75V8c0-1.85.626-3.372 1.69-4.436"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAttachmentFilledSVG);
ForwardRef.displayName = "IconAttachmentFilled";
export { ForwardRef as IconAttachmentFilled };
